import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import RadioElement from './RadioElement';
import FormError from '../FormError';

const RadioField = ({ options, name, ...props }) => {
  const { formState: { errors } } = useFormContext();

  return (
    <>
      <div className="w-auto row">
        {options.map((option) => (
          <RadioElement key={option.label} nbElements={options.length} option={option} name={name} {...props}/>
        ))}
      </div>

      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

RadioField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })).isRequired,
  name: PropTypes.string.isRequired
};

export default RadioField;
